<template>
    <div class="wrap">
        <div class="containter">
            <type-menu ref="typeMenu" @onChangeMenu="onChangeMenu"></type-menu>
            <div class="content" v-loading="loading">
                <div class="c-header">
                    <div class="header-group-left">
                        <el-button type="primary" size="mini" @click="open">添加直播</el-button>
                        <el-button class="el-icon-s-order" size="mini" @click="openForm">表单管理</el-button>
                        <!-- <el-button type="danger" size="mini" :disabled="!delAccess" @click="delAll">删除</el-button> -->
                        <!-- <el-dropdown>
                            <el-button type="default" plain size="mini"> 批量操作<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>批量删除</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown> -->
                    </div>
                    <div class="header-group-right">
                        <div>
                            <el-input placeholder="请输入内容" v-model="query.keyword" class="input-with-select" size="mini">
                                <el-button slot="append" icon="el-icon-search" @click="getList"></el-button>
                            </el-input>
                        </div>
                    </div>
                </div>

                <!-- <div class="c-header">
                    <el-checkbox :value="checked" @change="checkAll">全选</el-checkbox>
                </div> -->

                <div class="c-main">
                    <div class="overflow-container">
                        <div class="card">
                            <div class="card-item" v-for="item in list" :key="item._id">
                                <div class="card-item__title">
                                    <div class="text">{{ item.title }}</div>
                                    <el-tag :type="statusStyle(item.status)" class="tag" size="mini">{{ item.status
                                        }}</el-tag>
                                    <el-button type="text" class="el-icon-document-copy"
                                        @click="copy(item.liveUrl)">复制</el-button>
                                </div>
                                <div class="card-item__content">
                                    <div class="card-item__img">
                                        <el-image :src="item.cover" :preview-src-list="[item.cover]"> </el-image>
                                    </div>
                                    <div class="content__right">
                                        <div class="card-detail">
                                            <span class="card-detail__name">直播时间： {{ item.liveTime }} - {{ item.overTime
                                                }}</span>
                                        </div>
                                        <div class="card-detail desc">
                                            <span class="card-detail__name">标签：</span>
                                            <el-tag size="medium" :key="tag" v-for="tag in item.tags">
                                                {{ tag }}
                                            </el-tag>
                                        </div>

                                        <div class="card-detail control">
                                            <el-button type="text" class="el-icon-setting"
                                                @click="handleCommand({ type: 'edit', data: item })">直播编辑</el-button>
                                            <!-- <el-button type="text" class="el-icon-setting"
                                                @click="handleCommand({ type: 'ticket', data: item })">门票管理</el-button> -->
                                            <el-button type="text" class="el-icon-bell"
                                                @click="handleCommand({ type: 'sendNotification', data: item })">发送通知</el-button>
                                            <el-button type="text" class="el-icon-delete"
                                                @click="handleCommand({ type: 'del', data: item._id })">删除</el-button>
                                        </div>
                                    </div>
                                </div>


                                <!-- <div class="card-control">
                                    <el-checkbox class="checkbox" v-model="item.checked"></el-checkbox>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="page">
                        <el-pagination class="" @current-change="handleCurrentChange" :current-page="query.page"
                            :page-sizes="[10, 20, 50, 100]" :page-size="query.pageSize"
                            layout="total, prev, pager, next, jumper" :total="query.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <!-- 直播编辑 -->
        <el-dialog width="1200px" :title="dialogTitle" :visible.sync="dialogVisible">
            <el-form :model="form" ref="ruleForm" :rules="rules" label-width="120px">
                <div class="article-form">
                    <div class="article-form-left">
                        <el-form-item label="标题" prop="title">
                            <el-input v-model="form.title" size="small"></el-input>
                        </el-form-item>

                        <el-form-item label="详情" prop="description">
                            <FaRichText style="width: 100%;height: 500px" v-model="form.description" />
                        </el-form-item>

                    </div>
                    <div class="article-form-right">
                        <div class="article-form-right-item">
                            <el-form-item label="分类" prop="category">
                                <el-select v-model="form.category" placeholder="请选择分类" @change="handleCategoryChange">
                                    <el-option v-for="item in categoryOptions" :key="item._id" :label="item.name" :value="item._id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            
                            <el-form-item label="子分类" prop="subCategory">
                                <el-select v-model="form.subCategory" placeholder="请选择子分类" :disabled="!form.category || !subCategoryOptions.length" clearable>
                                    <el-option v-for="item in subCategoryOptions" :key="item.id" :label="item.name" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="直播链接" prop="liveUrl">
                                <el-input v-model="form.liveUrl" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="标签" prop="tags">
                                <el-tag size="medium" :key="tag" v-for="tag in form.tags" closable
                                    :disable-transitions="false" @close="handleClose(tag)">
                                    {{ tag }}
                                </el-tag>
                                <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue"
                                    ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm"
                                    @blur="handleInputConfirm">
                                </el-input>
                                <el-button v-else class="button-new-tag" size="small" @click="showInput">+
                                    添加标签</el-button>
                            </el-form-item>
                            <el-form-item label="开始时间" prop="liveTime">
                                <el-date-picker v-model="form.liveTime" type="datetime" size="small"
                                    placeholder="选择直播开始时间">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="结束时间" prop="overTime">
                                <el-date-picker v-model="form.overTime" type="datetime" size="small"
                                    placeholder="选择直播结束时间">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="直播封面" prop="cover">
                                <FaImageUpload v-model="form.cover" :maxCount="1" />
                            </el-form-item>
                            <el-form-item label="关联表单" prop="formId">
                                <el-select v-model="form.formId" placeholder="请选择">
                                    <el-option v-for="item in formOptions" value-key="form_id" :key="item.form_id"
                                        :label="item.title" :value="item.form_id">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="关联站点" prop="site">
                                <el-select v-model="form.site" placeholder="请选择" clearable >
                                    <el-option v-for="item in siteList" value-key="_id" :key="item._id"
                                        :label="item.name" :value="item._id">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="表单启用" prop="formEnabled">
                                <el-switch v-model="form.formEnabled"></el-switch>
                            </el-form-item>
                            <el-form-item label="支付启用" prop="paymentEnabled">
                                <el-switch v-model="form.paymentEnabled"></el-switch>
                            </el-form-item>
                            <el-form-item label="回放启用" prop="playbackEnabled">
                                <el-switch v-model="form.playbackEnabled"></el-switch>
                            </el-form-item>
                            <el-form-item label="开播通知" prop="broadcastEnabled">
                                <el-switch v-model="form.broadcastEnabled"></el-switch>
                            </el-form-item>
                            <el-form-item v-if="form.broadcastEnabled" label="会议地址类型">
                                <el-radio-group v-model="form.meetingAddressType">
                                    <el-radio label="0">在线会议</el-radio>
                                    <el-radio label="1">线下地址</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item v-if="form.broadcastEnabled && form.meetingAddressType === '1'" label="会议地址">
                                <el-input v-model="form.meetingAddress" size="small" placeholder="请输入会议地址"></el-input>
                            </el-form-item>
                            <el-form-item v-if="form.broadcastEnabled" label="提前通知时间">
                                <el-select v-model="form.broadcastAdvanceTime" size="small" placeholder="请选择提前通知时间">
                                    <el-option label="10分钟" value="10"></el-option>
                                    <el-option label="20分钟" value="20"></el-option>
                                    <el-option label="30分钟" value="30"></el-option>
                                    <el-option label="40分钟" value="40"></el-option>
                                    <el-option label="50分钟" value="50"></el-option>
                                    <el-option label="60分钟" value="60"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="价格" prop="price">
                                <el-input v-model="form.price" size="small" style="width: 240px;">
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 门票管理 -->
        <el-dialog width="1200px" :title="dialogTitleTicket" :visible.sync="dialogVisibleTicket">
            <!-- 添加门票按钮 -->
            <div style="margin-bottom: 10px; text-align: right;">
                <el-button type="primary" @click="handleCommand({ type: 'editTicket', data: null })">添加门票</el-button>
            </div>

            <el-table :data="ticketListData" style="width: 100%">
                <el-table-column label="门票名称" prop="ticketName" />
                <el-table-column label="价格" prop="ticketPrice" />
                <el-table-column label="已售/总数" prop="sold" />
                <el-table-column label="销售状态" prop="saleStatus">
                    <template slot-scope="scope">
                        <el-tag 
                        :type="scope.row.saleStatus == 1 ? 'success' : scope.row.saleStatus == 0 ? 'warning' : 'danger'"
                        >
                        {{ scope.row.saleStatus == 1 ? '售票中' : scope.row.saleStatus == 0 ? '未开始' : '已结束' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="开始售票时间" width="180px" prop="startTime" />
                <el-table-column label="结束售票时间" width="180px" prop="endTime" />
                <el-table-column label="启用状态" prop="status">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.status" @change="handleStatusChange(scope.row)" />
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="180px">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="handleCommand({ type: 'editTicket', data: scope.row })">编辑</el-button>
                        <el-button size="mini" type="danger" @click="handleCommand({ type: 'delTicket', data: scope.row })">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>




        <!-- 门票编辑 -->
        <el-dialog width="1200px" :title="dialogTitleTicketDetails" :visible.sync="dialogVisibleTicketDetails">
            <el-form :model="formTicket" ref="ruleFormTicket" :rules="rulesTicket" label-width="120px">
            <div class="ticket-form">
                <div class="ticket-form-left">
                <!-- 门票名称 -->
                <el-form-item label="门票名称" prop="ticketName">
                    <el-input v-model="formTicket.ticketName" size="small"></el-input>
                </el-form-item>

                <!-- 门票说明 -->
                <el-form-item label="门票说明" prop="ticketDescription">
                    <el-input type="textarea" v-model="formTicket.ticketDescription" size="small" placeholder="请输入门票说明"></el-input>
                </el-form-item>

                <!-- 售票时间 -->
                <el-form-item label="售票开始时间" prop="startTime">
                    <el-date-picker v-model="formTicket.startTime" type="datetime" size="small" placeholder="选择开始售票时间"></el-date-picker>
                </el-form-item>
                
                <el-form-item label="售票结束时间" prop="endTime">
                    <el-date-picker v-model="formTicket.endTime" type="datetime" size="small" placeholder="选择结束售票时间"></el-date-picker>
                </el-form-item>
                </div>

                <div class="ticket-form-right">
                <!-- 门票价格 -->
                <el-form-item label="门票价格" prop="ticketPrice">
                    <el-input v-model="formTicket.ticketPrice" size="small" style="width: 240px;">
                    <template slot="append">元</template>
                    </el-input>
                </el-form-item>

                <!-- 门票数量 -->
                <el-form-item label="门票数量" prop="ticketQuantity">
                    <el-input v-model="formTicket.ticketQuantity" size="small" style="width: 240px;"></el-input>
                </el-form-item>

                <!-- 免费/付费 -->
                <el-form-item label="是否付费" prop="isPaid">
                    <el-switch v-model="formTicket.isPaid" active-text="付费" inactive-text="免费"></el-switch>
                </el-form-item>

                <!-- 启用状态 -->
                <el-form-item label="启用状态" prop="status">
                    <el-switch v-model="formTicket.status" active-text="启用" inactive-text="禁用"></el-switch>
                </el-form-item>
                </div>
            </div>
            </el-form>

            <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibleTicketDetails = false">取消</el-button>
            <el-button type="primary" @click="saveTicket('ruleFormTicket')">确定</el-button>
            </span>
        </el-dialog>


        <el-dialog v-if="formDialogVisible" fullscreen :title="formDialogtitle" :visible.sync="formDialogVisible">
            <iframe allow='clipboard-read; clipboard-write' class="form-iframe" :src="formDialogUrl"
                frameborder="0"></iframe>
        </el-dialog>
    </div>
</template>

<script>
import { getLiveList, getLiveDetail, saveLive, delLive, getSiteTypeList, ticketList, ticketSave, ticketView, ticketDelete, getLiveTypeList, sendNotificationToAll } from "@/api/material"
import TypeMenu from "./components/TypeMenu.vue"
import global from "@/config/global";
import axios from "axios";
import request from "@/utils/request";

export default {
    props: {
        typeId: String,
    },
    components: {
        TypeMenu,
    },
    data() {
        const validatePrice = (rule, value, callback) => {
            const reg = /^\d+(\.\d{1,2})?$/;
            if (value === '') {
                callback();
            } else if (!reg.test(value)) {
                callback(new Error('请输入正确的价格格式，最多两位小数'));
            } else {
                callback();
            }
        };
        return {
            checked: false,
            loading: true,
            list: [],
            category: "",
            subCategory: void 0,
            currentRoomId: null, // 当前直播间ID
            categoryOptions: [], // 分类选项
            subCategoryOptions: [], // 子分类选项
            initializingForm: false, // 表单初始化标志，避免watch触发

            dialogVisible: false,
            dialogVisibleTicket: false,
            dialogVisibleDetails: false,
            dialogVisibleTicketDetails: false,
            dialogTitle: "",
            dialogTitleTicket: "",
            dialogTitleTicketDetails: "",
            inputVisible: false,
            inputValue: '',
            form: {
                _id: void 0,
                title: "", //标题
                cover: "", //封面
                description: "", //简介
                tags: [], //标签
                liveTime: "",   // 直播开始时间
                overTime: "",  // 直播结束时间
                liveUrl: "",  // 直播地址
                formEnabled: true, // 表单开关 0关 1开
                formId: "", // 表单ID
                paymentEnabled: true, // 付费开关 0关 1开
                playbackEnabled: false, // 回放开关 0关 1开
                broadcastEnabled: false, // 开播通知开关
                broadcastAdvanceTime: 30, // 提前通知时间(分钟)
                meetingAddressType: 0, // 会议地址类型: 0=在线会议, 1=线下地址
                meetingAddress: '', // 会议地址
                price: 0, // 付费价格
                site: '', //绑定的站点ID
                category: '', // 分类ID
                subCategory: '' // 子分类ID
            },
            ticketListData: [], // 门票列表数据
            query: {
                page: 1,
                total: 0,
                pageSize: 10,
                keyword: ''
            },
            formDialogVisible: false,
            formDialogtitle: "",
            formDialogUrl: "",
            formTicket: {
                ticketName: '', // 门票名称
                ticketDescription: '', // 门票说明
                startTime: '', // 售票时间
                endTime: '', // 售票时间
                ticketPrice: '', // 门票价格
                ticketQuantity: '', // 门票数量
                isPaid: false, // 是否付费
                status: false, // 启用状态
            },
            rulesTicket: {
                ticketName: [{ required: true, message: '请输入门票名称', trigger: 'blur' }],
                ticketPrice: [{ required: true, message: '请输入门票价格', trigger: 'blur' }],
                ticketQuantity: [{ required: true, message: '请输入门票数量', trigger: 'blur' }],
                startTime: [{ required: true, message: '请选择开始售票时间', trigger: 'change' }],
                endTime: [{ required: true, message: '请选择结束售票时间', trigger: 'change' }],
            },
            rules: {
                title: [
                    { required: true, message: '请输入标题', trigger: 'blur' },
                ],
                cover: [
                    { required: true, message: '请输入封面', trigger: 'blur' },
                ],
                liveTime: [
                    { required: true, message: '请设置直播开始时间', trigger: 'blur' },
                ],
                overTime: [
                    { required: true, message: '请设置直播结束时间', trigger: 'blur' },
                ],
                price: [
                    { validator: validatePrice, trigger: 'blur' }
                ],
                category: [
                    { required: true, message: '请选择分类', trigger: 'change' }
                ],
                meetingAddressType: [
                    { required: false }
                ],
                meetingAddress: [
                    { required: false }
                ]
            },
            formOptions: [],
            siteList: [],
        };
    },

    computed: {
        delAccess() {
            return this.list.some(item => item.checked === true);
        },
    },
    watch: {
        list: {
            handler(val) {
                if (val.length === 0) {
                    this.checked = false;
                    return
                }
                const tag = val.every((item) => item.checked === true);

            },
            deep: true,
        },
        'form.broadcastEnabled': {
            handler(newVal, oldVal) {
                // 只有当用户手动开启开播通知时，才默认选择在线会议
                // 表单初始化时不触发此逻辑
                if (newVal && !oldVal && !this.initializingForm) {
                    // 开启开播通知时，默认选择在线会议（使用字符串类型）
                    this.form.meetingAddressType = '0';
                }
            },
        },
        'form.meetingAddressType': {
            handler(newVal) {
                console.log('meetingAddressType changed to:', newVal);
            },
        },
    },
    methods: {
        statusStyle(status) {
            return {
                '即将开播': 'warning',
                '直播中': '',
                '未开始': 'warning',
                '已结束': 'info',
            }[status]
        },
        onChangeMenu({ id, cid }) {
            this.category = id;
            this.subCategory = cid;
            this.getList();
        },
        async initList() {
            await this.getList();
        },

        async getList() {
            try {
                this.loading = true;
                
                const { page, pageSize } = this.query;
                // 添加时间戳参数，避免缓存
                const timestamp = new Date().getTime();
                
                const { status, data, message } = await getLiveList({
                    category: this.category,
                    subCategory: this.subCategory,
                    page: page,
                    pageSize: pageSize,
                    title: this.query.keyword,
                    _t: timestamp // 添加时间戳参数，避免缓存
                });
                
                if (status == '10000') {
                    // 确保数据是最新的
                    this.list = data.rooms.map((item) => {
                        return {
                            checked: false,
                            ...item,
                        };
                    });
                    this.query.total = data.total;
                    
                    // 刷新分类选项
                    if (!this.categoryOptions.length) {
                        await this.getCategoryOptions();
                    }
                } else {
                    throw new Error(message);
                }
            } catch (error) {
                this.$message.error(error || '获取数据失败');
            } finally {
                this.loading = false;
            }
        },

        handleCurrentChange(page) {
            this.query.page = page;
            this.getList();
        },

        async open(data) {
            this.dialogTitle = data?._id ? "编辑直播" : "添加直播";
            console.log('打开对话框，数据:', data);
            
            // 先获取分类数据
            await this.getCategoryOptions();
            
            if (data && data._id) {
                try {
                    // 编辑模式：重新调用详情接口获取完整数据
                    console.log('编辑模式，重新获取详情数据:', data._id);
                    
                    // 调用详情接口获取最新数据
                    const { status, data: detailData } = await getLiveDetail({ id: data._id });
                    if (status == '10000') {
                        console.log('从详情接口获取的数据:', detailData);
                        
                        // 深拷贝数据
                        const formData = JSON.parse(JSON.stringify(detailData));
                        
                        // 确保子分类为空字符串时设置为空值，以便清除选择
                        if (formData.subCategory === '') {
                            formData.subCategory = '';
                            console.log('子分类为空字符串，已设置为空值');
                        }
                        
                        // 设置初始化标志，避免watch触发
                    this.initializingForm = true;
                    
                    // 调试日志：转换前的数据
                        console.log('转换前的meetingAddressType:', formData.meetingAddressType, typeof formData.meetingAddressType);
                        
                        // 会议地址类型处理：确保是字符串类型
                        let convertedType = '0'; // 默认在线会议
                        console.log('meetingAddressType原始值:', formData.meetingAddressType, '类型:', typeof formData.meetingAddressType);
                        
                        // 如果meetingAddressType未定义，默认设置为在线会议
                        if (formData.meetingAddressType === undefined || formData.meetingAddressType === null) {
                            convertedType = '0'; // 在线会议
                        } else if (typeof formData.meetingAddressType === 'number') {
                            // 如果是数值类型，转换为字符串
                            convertedType = formData.meetingAddressType.toString();
                        } else if (typeof formData.meetingAddressType === 'string') {
                            // 如果是字符串类型，进行转换
                            if (formData.meetingAddressType === 'offline' || formData.meetingAddressType === '1') {
                                convertedType = '1'; // 线下地址
                            } else {
                                convertedType = '0'; // 在线会议
                            }
                        } else {
                            // 其他类型，默认为在线会议
                            convertedType = '0';
                        }
                        
                        console.log('meetingAddressType转换后:', convertedType, '类型:', typeof convertedType);
                        console.log('转换后的meetingAddressType:', convertedType, typeof convertedType);
                        
                        // 设置表单数据
                    this.form = {
                        ...formData,
                        // 确保会议地址相关字段有正确的值
                        broadcastEnabled: formData.broadcastEnabled !== undefined ? formData.broadcastEnabled : false,
                        broadcastAdvanceTime: formData.broadcastAdvanceTime !== undefined ? formData.broadcastAdvanceTime : 30,
                        meetingAddressType: convertedType, // 确保是字符串类型
                        meetingAddress: formData.meetingAddress || ''
                    };
                    
                    // 调试日志：表单数据
                    console.log('设置后的表单数据:', this.form.meetingAddressType, typeof this.form.meetingAddressType);
                    
                    // 初始化完成后清除标志
                    this.$nextTick(() => {
                        this.initializingForm = false;
                    });
                        
                        console.log('编辑模式设置的表单数据:', {
                            meetingAddressType: this.form.meetingAddressType,
                            meetingAddress: this.form.meetingAddress,
                            broadcastEnabled: this.form.broadcastEnabled
                        });
                    }
                    
                    // 确保价格有默认值
                    if (this.form.price === undefined || this.form.price === null) {
                        this.form.price = 0;
                    }
                    
                    console.log('表单数据处理前:', {
                        category: this.form.category,
                        subCategory: this.form.subCategory,
                        categoryOptions: this.categoryOptions.map(c => ({ _id: c._id, name: c.name }))
                    });
                    
                    // 如果是编辑模式，设置子分类选项
                    if (this.form.category) {
                        // 确保分类存在于选项中
                        const categoryExists = this.categoryOptions.some(item => item._id === this.form.category);
                        console.log('分类是否存在:', categoryExists);
                        
                        if (!categoryExists) {
                            // 如果分类不存在，清空分类和子分类
                            console.log('分类不存在，清空分类和子分类');
                            this.form.category = '';
                            this.form.subCategory = '';
                            this.subCategoryOptions = [];
                        } else {
                            // 设置子分类选项
                            await this.setSubCategoryOptions(this.form.category);
                            console.log('子分类选项:', this.subCategoryOptions.map(c => ({ id: c.id, name: c.name })));
                            
                            // 确保子分类值有效
                            if (this.form.subCategory) {
                                const validSubCategory = this.subCategoryOptions.some(item => item.id === this.form.subCategory);
                                console.log('子分类是否有效:', validSubCategory, '当前子分类值:', this.form.subCategory);
                                
                                if (!validSubCategory) {
                                    console.log('子分类无效，清空子分类');
                                    this.form.subCategory = '';
                                }
                            }
                        }
                    } else {
                        // 确保子分类选项为空数组
                        console.log('没有分类，清空子分类选项');
                        this.subCategoryOptions = [];
                        this.form.subCategory = '';
                    }
                    
                    // 强制更新表单数据
                    this.$nextTick(() => {
                        // 确保表单被更新
                        if (this.$refs.ruleForm) {
                            // 验证字段，不重置表单（避免覆盖已有数据）
                            this.$refs.ruleForm.validateField('category');
                            this.$refs.ruleForm.validateField('subCategory');
                            
                            console.log('强制更新表单数据后:', {
                                category: this.form.category,
                                subCategory: this.form.subCategory,
                                meetingAddressType: this.form.meetingAddressType,
                                broadcastEnabled: this.form.broadcastEnabled
                            });
                        }
                    });
                    
                    console.log('表单数据处理后:', {
                        category: this.form.category,
                        subCategory: this.form.subCategory,
                        subCategoryOptions: this.subCategoryOptions.map(c => ({ id: c.id, name: c.name }))
                    });
                } catch (error) {
                    console.error('处理编辑数据失败:', error);
                    this.$message.error('处理数据失败，请重试');
                }
            } else {
                // 重置表单
                this.form = {
                    _id: void 0,
                    title: "",
                    cover: "",
                    description: "",
                    tags: [],
                    liveTime: "",
                    overTime: "",
                    liveUrl: "",
                    formEnabled: true,
                    formId: "",
                    paymentEnabled: true,
                    playbackEnabled: false, // 回放开关默认关闭
                    broadcastEnabled: false, // 开播通知开关默认关闭
                    broadcastAdvanceTime: 30, // 默认提前30分钟通知
                    meetingAddressType: '0', // 默认在线会议（字符串类型）
                    meetingAddress: '', // 默认会议地址为空
                    price: 0, // 默认价格为0
                    site: '',
                    category: this.category || '', // 默认使用当前选中的分类
                    subCategory: '' // 默认子分类为空
                };
                
                // 如果有默认分类，设置子分类选项
                if (this.form.category) {
                    await this.setSubCategoryOptions(this.form.category);
                } else {
                    // 确保子分类选项为空数组
                    this.subCategoryOptions = [];
                }
            }
            
            this.dialogVisible = true;
            
            // 不要在这里重置表单，因为会清空我们设置的值
            // this.$nextTick(() => {
            //     this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
            // });
            
            await Promise.all([this.getFormList(), this.getSiteList()]);
        },
        
        // 获取分类选项
        async getCategoryOptions() {
            try {
                const { status, data, message } = await getLiveTypeList({
                    page: 1,
                    pageSize: 100,
                });
                if (status == '10000') {
                    this.categoryOptions = data.categories;
                } else {
                    this.$message.error(message || '获取分类失败');
                }
            } catch (error) {
                console.error('获取分类失败:', error);
                this.$message.error('获取分类失败，请重试');
            }
        },
        
        // 设置子分类选项
        async setSubCategoryOptions(categoryId) {
            console.log('设置子分类选项，分类ID:', categoryId);
            
            if (!categoryId) {
                console.log('分类ID为空，清空子分类选项');
                this.subCategoryOptions = [];
                return;
            }
            
            // 根据选中的分类ID找到对应的分类对象
            const selectedCategory = this.categoryOptions.find(item => item._id === categoryId);
            console.log('找到的分类对象:', selectedCategory ? {
                _id: selectedCategory._id,
                name: selectedCategory.name,
                hasChild: !!selectedCategory.child,
                childCount: selectedCategory.child ? selectedCategory.child.length : 0
            } : '未找到');
            
            // 设置子分类选项，确保是响应式的
            if (selectedCategory && selectedCategory.child && selectedCategory.child.length > 0) {
                console.log('子分类数据:', JSON.stringify(selectedCategory.child));
                
                // 确保子分类数据结构正确
                const validChildren = selectedCategory.child.filter(child => 
                    child && typeof child === 'object' && child.id && child.name
                );
                
                if (validChildren.length > 0) {
                    console.log('有效的子分类数据:', validChildren.length);
                    // 使用Vue的响应式方法设置子分类选项
                    this.subCategoryOptions = [...validChildren];
                    
                    // 确保子分类选项已经更新
                    this.$nextTick(() => {
                        console.log('子分类选项已更新:', this.subCategoryOptions.map(c => ({ id: c.id, name: c.name })));
                    });
                } else {
                    console.log('子分类数据结构不正确，设置为空数组');
                    this.subCategoryOptions = [];
                }
            } else {
                console.log('没有子分类数据，设置为空数组');
                this.subCategoryOptions = [];
            }
            
            console.log('设置后的子分类选项:', this.subCategoryOptions.map(c => ({ id: c.id, name: c.name })));
        },
        
        // 处理分类变化
        async handleCategoryChange(categoryId) {
            console.log('分类变化:', categoryId);
            
            // 清空子分类选择，确保使用Vue的响应式方法
            this.form.subCategory = '';
            console.log('已清空子分类值');
            
            // 强制更新表单数据
            this.$nextTick(() => {
                // 确保表单被更新
                this.$refs.ruleForm && this.$refs.ruleForm.validateField('category');
                this.$refs.ruleForm && this.$refs.ruleForm.validateField('subCategory');
            });
            
            // 设置新的子分类选项
            await this.setSubCategoryOptions(categoryId);
            
            console.log('分类变化后的表单数据:', {
                category: this.form.category,
                subCategory: this.form.subCategory,
                subCategoryOptions: this.subCategoryOptions.map(c => ({ id: c.id, name: c.name }))
            });
        },
        
        async openTicket(data) {
            this.dialogTitleTicket = "门票管理";
            this.currentRoomId = data._id; // 设置当前直播间ID
            this.dialogVisibleTicket = true;
            this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
            await Promise.all([this.getTicketList(data._id)])
        },

        async editTicket(data) {
            this.dialogTitleTicketDetails = data?._id ? "编辑门票." : "添加门票";
            
            // 先重置表单验证
            this.$nextTick(() => {
                this.$refs.ruleFormTicket && this.$refs.ruleFormTicket.clearValidate();
            });

            // 编辑模式：使用传入的数据（已经是从列表接口获取的数据，可能缺少一些字段）
                    // 为了确保获取到完整的数据，重新调用详情接口
                    if (data?._id) {
                        try {
                            const { status, data: detailData } = await getLiveDetail({ id: data._id });
                            if (status == '10000') {
                                // 使用详情接口返回的数据
                                const formData = JSON.parse(JSON.stringify(detailData));
                                
                                // 会议地址类型处理：确保是字符串类型
                                let convertedType = '0'; // 默认在线会议
                                if (typeof formData.meetingAddressType === 'number') {
                                    // 如果是数值类型，转换为字符串
                                    convertedType = formData.meetingAddressType.toString();
                                } else if (typeof formData.meetingAddressType === 'string') {
                                    // 如果是字符串类型，进行转换
                                    if (formData.meetingAddressType === 'offline' || formData.meetingAddressType === '1') {
                                        convertedType = '1'; // 线下地址
                                    } else {
                                        convertedType = '0'; // 在线会议
                                    }
                                } else {
                                    // 其他类型，默认为在线会议
                                    convertedType = '0';
                                }
                                
                                // 设置门票表单数据，不影响主表单
                                this.formTicket = {
                                    ...formData,
                                    // 确保会议地址相关字段有正确的值
                                    broadcastEnabled: formData.broadcastEnabled !== undefined ? formData.broadcastEnabled : false,
                                    broadcastAdvanceTime: formData.broadcastAdvanceTime !== undefined ? formData.broadcastAdvanceTime : 30,
                                    meetingAddressType: convertedType, // 确保是字符串类型
                                    meetingAddress: formData.meetingAddress || ''
                                };
                                
                                console.log('从详情接口获取的数据（门票）:', this.formTicket);
                            }
                        } catch (error) {
                            console.error('获取直播详情失败:', error);
                            // 如果获取详情失败，使用传入的数据作为后备
                            const formData = JSON.parse(JSON.stringify(data));
                            // 会议地址类型处理：确保是字符串类型
                            let convertedType = '0'; // 默认在线会议
                            if (typeof formData.meetingAddressType === 'number') {
                                // 如果是数值类型，转换为字符串
                                convertedType = formData.meetingAddressType.toString();
                            } else if (typeof formData.meetingAddressType === 'string') {
                                // 如果是字符串类型，进行转换
                                if (formData.meetingAddressType === 'offline' || formData.meetingAddressType === '1') {
                                    convertedType = '1'; // 线下地址
                                } else {
                                    convertedType = '0'; // 在线会议
                                }
                            } else {
                                // 其他类型，默认为在线会议
                                convertedType = '0';
                            }
                            
                            this.formTicket = {
                                ...formData,
                                broadcastEnabled: formData.broadcastEnabled !== undefined ? formData.broadcastEnabled : false,
                                broadcastAdvanceTime: formData.broadcastAdvanceTime !== undefined ? formData.broadcastAdvanceTime : 30,
                                meetingAddressType: convertedType, // 确保是字符串类型
                                meetingAddress: formData.meetingAddress || ''
                            };
                        }
                    } else {
                // 添加模式：重置表单数据
                this.formTicket = {
                    ticketName: '', // 门票名称
                    ticketDescription: '', // 门票说明
                    startTime: '', // 售票时间
                    endTime: '', // 售票时间
                    ticketPrice: '', // 门票价格
                    ticketQuantity: '', // 门票数量
                    isPaid: false, // 是否付费
                    status: false, // 启用状态
                };
            }

            this.dialogVisibleTicketDetails = true;
        },

        // 门票列表
        async getTicketList(id) {
            const params = {
                page: 1,
                pageSize: 20,
                roomId: id
            };
            const { status, data, message } = await ticketList(params);
            if (status == '10000') {
                this.ticketListData = data.tickets;
            } else {
                this.$message.error(message);
            }
        },

        // 保存门票信息
        saveTicket(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    try {
                        const isAdd = !this.formTicket._id;
                        const saveData = {
                            ...this.formTicket,
                            roomId: this.currentRoomId,
                            status: this.formTicket.status !== undefined ? this.formTicket.status : false
                        };
                        
                        // 如果是编辑，需要传入id
                        if (!isAdd) {
                            saveData.id = this.formTicket._id;
                        }

                        const { status, message } = await ticketSave(isAdd, saveData);
                        
                        if (status == '10000') {
                            this.$message.success(isAdd ? '添加成功！' : '更新成功！');
                            this.dialogVisibleTicketDetails = false;
                            // 重新获取门票列表
                            await this.getTicketList(this.currentRoomId);
                        } else {
                            this.$message.error(message || '操作失败');
                        }
                    } catch (error) {
                        console.error('保存门票失败:', error);
                        this.$message.error('操作失败，请重试');
                    }
                }
            });
        },

        // 删除门票
        async delTicket(ticket) {
            try {
                await this.$confirm('此操作将永久删除该门票, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                });

                const { status, message } = await ticketDelete({
                    id: ticket._id
                });

                if (status == '10000') {
                    this.$message.success('删除成功！');
                    // 重新获取门票列表
                    await this.getTicketList(this.currentRoomId);
                } else {
                    this.$message.error(message || '删除失败');
                }
            } catch (error) {
                if (error !== 'cancel') {
                    console.error('删除门票失败:', error);
                    this.$message.error('删除失败，请重试');
                }
            }
        },

        async getFormList() {
            try {
                const res = await axios.get('/service/questionnaire_list', {
                    headers: {
                        'Authorization': 'Bearer skip'
                    },
                    params: {
                        class_id: 5,   // E建云特定分类
                        page: 1,
                        limit: 12
                    }
                })
                if (res.data?.code === 200) {
                    this.formOptions = res.data.data;
                }
            } catch (err) {
                console.error('获取表单列表失败:', err);
                // 设置空数组，避免undefined错误
                this.formOptions = [];
                // 不显示错误提示，因为这不是关键功能
            }
        },

        async getSiteList() {
            const { status, data, message } = await getSiteTypeList();
            if (status == '10000') {
                this.siteList = data;
            } else {
                this.$message.error(message);
            }
        },

        save() {
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    try {
                        this.loading = true;
                        console.log('保存表单数据:', this.form);
                        
                        // 确保价格有默认值
                        if (this.form.price === undefined || this.form.price === null || this.form.price === '') {
                            this.form.price = 0;
                        }
                        
                        // 确保tags是数组
                        if (!Array.isArray(this.form.tags)) {
                            this.form.tags = [];
                        }
                        
                        // 处理子分类值
                        // 如果子分类有值且在选项中存在，则使用该值
                        // 否则使用空字符串表示清空子分类
                        let subCategoryValue = '';
                        
                        if (this.form.subCategory && this.subCategoryOptions.some(item => item.id === this.form.subCategory)) {
                            subCategoryValue = this.form.subCategory;
                            console.log('使用有效的子分类值:', subCategoryValue);
                        } else {
                            console.log('子分类值无效或为空，使用空字符串');
                        }
                        
                        // 构建保存的数据
                        const { _id, description, ...restData } = this.form;
                        
                        // 处理会议地址类型：将字符串类型转换为数值类型
                        let meetingAddressTypeValue = 0; // 默认在线会议
                        if (typeof this.form.meetingAddressType === 'string') {
                            // 如果是字符串类型，转换为数值
                            if (this.form.meetingAddressType === '1') {
                                meetingAddressTypeValue = 1; // 线下地址
                            } else {
                                meetingAddressTypeValue = 0; // 在线会议
                            }
                        } else {
                            // 如果是数值类型，直接使用
                            meetingAddressTypeValue = this.form.meetingAddressType || 0;
                        }
                        
                        const payload = {
                            id: _id,
                            category: this.form.category,
                            subCategory: subCategoryValue,
                            description: description ? this.filterHtml(description) : '',
                            playbackEnabled: this.form.playbackEnabled, // 回放开关状态
                            broadcastEnabled: this.form.broadcastEnabled, // 开播通知开关状态
                            broadcastAdvanceTime: this.form.broadcastAdvanceTime, // 提前通知时间
                            meetingAddressType: meetingAddressTypeValue, // 会议地址类型（转换为数值类型）
                            meetingAddress: this.form.meetingAddress, // 会议地址
                            ...restData
                        };
                        
                        console.log('发送保存请求，数据:', payload);
                        
                        const { status, message } = await saveLive(payload);
                        
                        if (status == '10000') {
                            this.$message.success('保存成功');
                            this.dialogVisible = false;
                            
                            // 保存成功后立即刷新列表
                            await this.getList();
                            
                            // 如果是编辑模式，更新当前列表中的数据
                            if (_id) {
                                const index = this.list.findIndex(item => item._id === _id);
                                if (index !== -1) {
                                    // 获取最新数据
                                    const response = await getLiveDetail({ id: _id });
                                    if (response.status === '10000' && response.data) {
                                        // 更新列表中的数据
                                        this.$set(this.list, index, {
                                            ...response.data,
                                            checked: this.list[index].checked
                                        });
                                    }
                                }
                            }
                        } else {
                            throw new Error(message || '保存失败');
                        }
                    } catch (error) {
                        console.error('保存失败:', error);
                        this.$message.error(error.message || '保存失败');
                    } finally {
                        this.loading = false;
                    }
                } else {
                    return false;
                }
            });
        },

        del(ids) {
            this.$confirm("此操作将永久删除该项, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    const { status, message } = await delLive({
                        id: ids,
                    });
                    if (status == '10000') {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });
                        this.getList();
                        this.checked && (this.checked = false);
                    } else {
                        this.$message.error(message);
                    }
                })
                .catch(() => {
                    console.info("已取消删除!");
                });
        },

        openForm() {
            this.formDialogVisible = true;
            // this.formDialogtitle = '表单收集管理';
            this.formDialogUrl = `${global.formUrl}/admin/survey?skip_auth=1`;
        },

        delAll() {
            const ids = this.list.filter((item) => item.checked).map((item) => item._id).join(",");
            this.del(ids);
        },

        async sendNotification(room) {
            try {
                this.$confirm(`确定要为直播间"${room.title}"发送开播通知吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    this.loading = true;
                    
                    const response = await sendNotificationToAll({
                        roomId: room._id,
                        testMode: false
                    });
                    
                    if (response.status === '10000') {
                        // 检查是否有任务ID（使用任务队列系统）
                        if (response.data && response.data.taskId) {
                            const taskId = response.data.taskId;
                            
                            // 显示任务已创建的消息
                            this.$message({
                                message: '通知任务已创建，正在后台处理中...',
                                type: 'info',
                                duration: 3000
                            });
                            
                            // 显示任务状态对话框
                            this.showTaskStatusDialog(taskId, room.title);
                        } else {
                            // 兼容旧版本同步方式
                            this.$message.success(`通知发送成功！成功发送给 ${response.data.successCount} 个用户，失败 ${response.data.failCount} 个`);
                        }
                    } else {
                        this.$message.error(response.message || '发送通知失败');
                    }
                }).catch(() => {
                    this.$message.info('已取消发送通知');
                }).finally(() => {
                    this.loading = false;
                });
            } catch (error) {
                console.error('发送通知失败:', error);
                this.$message.error('发送通知失败: ' + error.message);
                this.loading = false;
            }
        },

        // 显示任务状态对话框
        showTaskStatusDialog(taskId, roomTitle) {
            // 使用Notification组件显示任务状态，这样可以更容易地更新内容
            const h = this.$createElement;
            let statusInterval;
            let notification;
            
            // 获取任务状态的函数
            const checkTaskStatus = async () => {
                try {
                    // 使用正确的API调用方式
                    const response = await request({
                        url: `/notification/task-status/${taskId}`,
                        method: 'GET'
                    });
                    
                    if (response.status === '10000') {
                        const taskData = response.data;
                        
                        let statusText = '';
                        let statusType = 'info';
                        
                        switch (taskData.status) {
                            case 'pending':
                                statusText = '等待处理';
                                statusType = 'info';
                                break;
                            case 'processing':
                                statusText = '正在处理';
                                statusType = 'warning';
                                break;
                            case 'completed':
                                // 检查是否有部分成功的结果
                                if (taskData.result && taskData.result.status === 'partial_success') {
                                    statusText = `部分成功 (${taskData.result.successCount || 0}/${(taskData.result.successCount || 0) + (taskData.result.failCount || 0)})`;
                                    statusType = 'warning';
                                } else {
                                    statusText = '已完成';
                                    statusType = 'success';
                                }
                                break;
                            case 'failed':
                                // 检查是否有成功发送的结果，如果有，则显示部分成功
                                if (taskData.result && (taskData.result.successCount > 0 || taskData.result.success_count > 0)) {
                                    statusText = `部分成功 (${taskData.result.successCount || taskData.result.success_count}/${(taskData.result.successCount || taskData.result.success_count) + (taskData.result.failCount || taskData.result.fail_count)})`;
                                    statusType = 'warning';
                                } else {
                                    statusText = '处理失败';
                                    statusType = 'error';
                                }
                                break;
                        }
                        
                        // 创建通知内容
                        const notificationContent = h('div', { style: 'padding: 10px;' }, [
                            h('h4', { style: 'margin-bottom: 10px;' }, `直播间"${roomTitle}"通知发送状态`),
                            h('p', `任务ID: ${taskId}`),
                            h('p', `任务状态: ${statusText}`),
                            h('p', `创建时间: ${new Date(taskData.createdAt).toLocaleString()}`),
                            taskData.startedAt ? h('p', `开始处理时间: ${new Date(taskData.startedAt).toLocaleString()}`) : null,
                            taskData.completedAt ? h('p', `完成时间: ${new Date(taskData.completedAt).toLocaleString()}`) : null,
                            taskData.result ? h('div', { style: 'margin-top: 10px;' }, [
                                h('h5', '执行结果:'),
                                h('p', `成功发送: ${taskData.result.successCount || 0} 个用户`),
                                h('p', `发送失败: ${taskData.result.failCount || 0} 个用户`)
                            ]) : null,
                            taskData.errorMessage ? h('p', { style: 'color: red; margin-top: 10px;' }, `错误信息: ${taskData.errorMessage}`) : null
                        ]);
                        
                        // 如果是第一次创建通知，或者任务已完成/失败，则创建/更新通知
                        if (!notification || taskData.status === 'completed' || taskData.status === 'failed') {
                            // 关闭之前的通知
                            if (notification) {
                                notification.close();
                            }
                            
                            // 创建新通知
                            notification = this.$notify({
                                title: '通知发送状态',
                                message: notificationContent,
                                type: statusType,
                                duration: taskData.status === 'completed' || taskData.status === 'failed' ? 0 : 0, // 0表示不自动关闭
                                showClose: true
                            });
                        } else {
                            // 更新现有通知内容
                            if (notification && notification.$el) {
                                const messageContainer = notification.$el.querySelector('.el-notification__content');
                                if (messageContainer) {
                                    // 清空现有内容
                                    messageContainer.innerHTML = '';
                                    // 添加新内容
                                    messageContainer.appendChild(notificationContent);
                                }
                            }
                        }
                        
                        // 如果任务已完成或失败，停止轮询
                        if (taskData.status === 'completed' || taskData.status === 'failed') {
                            clearInterval(statusInterval);
                        }
                    }
                } catch (error) {
                    console.error('获取任务状态失败:', error);
                    
                    // 检查是否是网络错误或服务器错误
                    if (error.response && error.response.status >= 500) {
                        // 服务器错误，停止轮询并显示错误
                        clearInterval(statusInterval);
                        this.$notify.error({
                            title: '错误',
                            message: '服务器错误，无法获取任务状态',
                            duration: 5000
                        });
                    } else if (error.response && error.response.status >= 400) {
                        // 客户端错误（如任务不存在），停止轮询并显示错误
                        clearInterval(statusInterval);
                        this.$notify.error({
                            title: '错误',
                            message: '获取任务状态失败: ' + (error.response.data.message || '未知错误'),
                            duration: 5000
                        });
                    } else {
                        // 网络错误或其他错误，不显示错误通知，继续轮询
                        // 这样可以避免在任务还在pending状态时显示错误通知
                        console.log('网络错误，继续轮询...');
                    }
                }
            };
            
            // 立即检查一次状态
            checkTaskStatus();
            
            // 每3秒检查一次任务状态
            statusInterval = setInterval(checkTaskStatus, 3000);
            
            // 5分钟后自动停止轮询
            setTimeout(() => {
                clearInterval(statusInterval);
            }, 5 * 60 * 1000);
        },

        handleCommand({ type: command, data }) {
            if (command === "edit") {
                // 如果是编辑，始终先获取最新的数据
                if (data && data._id) {
                    this.loading = true;
                    
                    // 使用组件内的getLiveDetail方法获取最新数据
                    getLiveDetail({ id: data._id })
                        .then(async response => {
                            const { status, data: detailData } = response;
                            if (status === '10000' && detailData) {
                                console.log('获取到最新数据:', detailData);
                                
                                // 先获取分类选项，确保分类数据已加载
                                await this.getCategoryOptions();
                                
                                // 如果有分类，先设置子分类选项
                                if (detailData.category) {
                                    await this.setSubCategoryOptions(detailData.category);
                                    console.log('编辑前设置子分类选项:', this.subCategoryOptions);
                                }
                                
                                // 先设置表单数据，再显示对话框
                                this.form = JSON.parse(JSON.stringify(detailData));
                                this.dialogTitle = "编辑直播";
                                
                                // 确保meetingAddressType是字符串类型
                                console.log('handleCommand中meetingAddressType原始值:', this.form.meetingAddressType, '类型:', typeof this.form.meetingAddressType);
                                
                                // 如果meetingAddressType未定义，默认设置为在线会议
                                if (this.form.meetingAddressType === undefined || this.form.meetingAddressType === null) {
                                    this.form.meetingAddressType = '0'; // 在线会议
                                } else if (typeof this.form.meetingAddressType !== 'string') {
                                    // 如果是数值类型，转换为字符串
                                    if (this.form.meetingAddressType === 1 || this.form.meetingAddressType === '1') {
                                        this.form.meetingAddressType = '1'; // 线下地址
                                    } else {
                                        this.form.meetingAddressType = '0'; // 在线会议
                                    }
                                } else {
                                    // 如果是字符串类型，进行转换
                                    if (this.form.meetingAddressType === 'offline' || this.form.meetingAddressType === '1') {
                                        this.form.meetingAddressType = '1'; // 线下地址
                                    } else {
                                        this.form.meetingAddressType = '0'; // 在线会议
                                    }
                                }
                                
                                console.log('handleCommand中meetingAddressType处理后:', this.form.meetingAddressType, '类型:', typeof this.form.meetingAddressType);
                                
                                // 设置初始化标志，避免watch触发
                                this.initializingForm = true;
                                
                                // 最后显示对话框
                                this.dialogVisible = true;
                                
                                // 在下一个tick中清除初始化标志
                                this.$nextTick(async () => {
                                    this.initializingForm = false;
                                    
                                    if (this.$refs.ruleForm) {
                                        // 确保表单被更新
                                        this.$refs.ruleForm.clearValidate();
                                        
                                        // 手动设置表单值，确保显示正确
                                        this.$set(this.form, 'category', detailData.category);
                                        this.$set(this.form, 'subCategory', detailData.subCategory);
                                        
                                        console.log('强制更新表单数据后:', {
                                            category: this.form.category,
                                            subCategory: this.form.subCategory,
                                            meetingAddressType: this.form.meetingAddressType
                                        });
                                    }
                                    
                                    // 加载其他必要数据
                                    await Promise.all([this.getFormList(), this.getSiteList()]);
                                });
                            } else {
                                this.$message.warning('获取最新数据失败，使用缓存数据');
                                this.open(data);
                            }
                        })
                        .catch(error => {
                            console.error('获取直播详情失败:', error);
                            this.$message.warning('获取最新数据失败，使用缓存数据');
                            this.open(data);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                } else {
                    this.open(data);
                }
            } else if (command === "del") {
                this.del(data);
            } else if (command === "sendNotification") {
                this.sendNotification(data);
            } else if (command === "ticket") {
                this.openTicket(data);
            } else if (command === "editTicket") {
                this.editTicket(data);
            } else if (command === "delTicket") {
                this.delTicket(data);
            }
        },

        copy(url) {
            if (navigator.clipboard && window.isSecureContext) {
                // 在安全域下使用 navigator.clipboard 提升效率
                navigator.clipboard.writeText(url).then(() => {
                    this.$message({
                        type: "success",
                        message: "已复制链接到剪贴板!",
                    });
                }).catch(err => {
                    this.$message.error('出现未知错误');
                    console.error('Failed to copy text to clipboard.', err);
                });
            }
            else {
                // 非安全域退回到 document.execCommand('copy');
                const textarea = document.createElement('textarea');
                textarea.value = url;
                document.body.appendChild(textarea);
                textarea.select();
                try {
                    const successful = document.execCommand('copy');
                    if (successful) {
                        this.$message({
                            type: "success",
                            message: "已复制链接到剪贴板!",
                        });
                    } else {
                        this.$message.error('复制失败');
                    }
                } catch (err) {
                    console.error('Fallback: Oops, unable to copy', err);
                }
                document.body.removeChild(textarea);
            }
        },

        checkAll() {
            const tag = !this.checked;
            this.list = this.list.map((item) => {
                return {
                    ...item,
                    checked: tag,
                };
            });
        },

        // 标签删除
        handleClose(tag) {
            this.form.tags.splice(this.form.tags.indexOf(tag), 1);
        },

        // 显示标签编辑框
        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },

        // 标签确认
        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.form.tags = [...new Set(this.form.tags), inputValue];
            }
            this.inputVisible = false;
            this.inputValue = '';
        },

        // 添加 HTML 过滤函数
        filterHtml(html) {
            // 移除潜在的危险标签和属性
            return html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
                .replace(/on\w+="[^"]*"/g, '')
                .replace(/javascript:/gi, '')
        },

        // 处理启用状态变化
        async handleStatusChange(ticket) {
            try {
                // 调用编辑接口更新状态
                const { status, message } = await ticketSave(false, {
                    id: ticket._id,
                    ticketName: ticket.ticketName,
                    ticketDescription: ticket.ticketDescription,
                    startTime: ticket.startTime,
                    endTime: ticket.endTime,
                    ticketPrice: ticket.ticketPrice,
                    ticketQuantity: ticket.ticketQuantity,
                    isPaid: ticket.isPaid,
                    roomId: ticket.roomId,
                    status: ticket.status
                });

                if (status == '10000') {
                    this.$message.success('状态更新成功！');
                } else {
                    this.$message.error(message || '状态更新失败');
                    // 如果更新失败，恢复原来的状态
                    ticket.status = !ticket.status;
                }
            } catch (error) {
                console.error('更新状态失败:', error);
                this.$message.error('状态更新失败，请重试');
                // 如果更新失败，恢复原来的状态
                ticket.status = !ticket.status;
            }
        },

        // 获取直播详情
        async getLiveDetail(id) {
            try {
                // 调用详情接口
                const response = await getLiveDetail({ id });
                console.log('获取直播详情返回数据:', JSON.stringify(response));
                
                // 如果成功，检查数据结构
                if (response.status === '10000' && response.data) {
                    console.log('直播详情数据结构:', {
                        hasCategory: !!response.data.category,
                        categoryValue: response.data.category,
                        hasSubCategory: !!response.data.subCategory,
                        subCategoryValue: response.data.subCategory
                    });
                }
                
                return response;
            } catch (error) {
                console.error('获取直播详情失败:', error);
                throw error;
            }
        },
    },
    created() {
        // 初始化子分类选项为空数组，确保响应式
        this.subCategoryOptions = [];
        this.initList();
    },
};
</script>
<style lang="scss" scoped>
.wrap {
    width: 100%;
    height: calc(100vh - 60px);

    .containter {
        width: 100%;
        height: 100%;
        display: flex;
        padding: 8px;

        .content {
            flex: 1 1 auto;
            min-width: 0;
            height: 100%;
            display: flex;
            flex-direction: column;
            padding: 0 0 10px 16px;
        }

        .c-header {
            display: flex;
            height: 32px;
            justify-content: space-between;
            align-items: center;

            &:nth-of-type(2n) {
                margin-top: 8px;
            }
        }

        .header-group-left {
            .el-button {
                min-width: 80px;

                &:first-child {
                    margin-right: 8px;
                }
            }
        }

        .c-main {
            position: relative;
            flex: 1 1 auto;
            min-height: auto;
            padding: 6px 0 42px;
            height: 100%;

            .overflow-container {
                height: 100%;
                overflow-y: auto;

                // 滚动条整体样式
                &::-webkit-scrollbar {
                    display: block;
                    width: 6px;
                    height: 6px;
                }

                // 滚动条轨道
                &::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 3px;
                }

                // 滚动条滑块
                &::-webkit-scrollbar-thumb {
                    background: #c1c1c1;
                    border-radius: 3px;

                    &:hover {
                        background: #a8a8a8;
                    }
                }
            }

            .page {
                display: flex;
                justify-content: flex-end;
                position: absolute;
                bottom: 6px;
                width: 100%;
            }
        }

        .card {
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            flex-direction: column;
        }

        .card-item {
            display: flex;
            flex-direction: column;
            padding: 16px 26px 16px;
            width: 100%;
            min-height: 200px;
            position: relative;

            &:nth-of-type(n+2) {
                padding-top: 0px;
            }

            &:not(:last-child) {
                &::after {
                    content: '';
                    display: block;
                    margin: 0 26px;
                    width: calc(100% - 52px);
                    height: 1px;
                    background: #ededed;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                }
            }

            &:hover {
                .card-item__img {
                    border: 1px solid #2061e6;
                }
            }

            .card-item__title {
                display: flex;
                gap: 12px;
                align-items: center;
                padding: 6px 0px;

                .text {
                    display: inline-block;
                    font-size: 16px;
                    font-weight: 400;
                    color: #333;
                }

                .tag {
                    display: inline-block;
                }
            }

            .card-item__content {
                display: flex;
            }

            .content__right {
                padding-left: 12px;
                flex: 1 1 auto;
                min-width: 0;
                display: flex;
                flex-direction: column;
            }



            .card-item__img {
                flex: 0 0 160px;
                height: 160px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #ededed;
                box-sizing: border-box;
                border: 1px solid transparent;

                img {
                    display: block;
                    max-width: 100%;
                    max-height: 100%;
                    object-fit: cover;
                }
            }

            .card-control {
                display: flex;
                align-items: center;
                position: absolute;
                width: 100%;
                top: 0;
                left: 0;
                padding: 4px 8px;

                .checkbox {
                    margin-right: auto;
                    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.12);
                }
            }
        }

        .card-detail {
            padding-top: 8px;

            .card-detail__name {
                font-size: 400;
                font-size: 14px;
                color: #6e6e6e;
            }

            &.desc {
                // 或者您实际使用的类名
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;
                word-break: break-all;
                line-height: 1.5; // 建议设置行高
            }

            &.control {
                margin-top: auto;
            }
        }
    }
}

.article-form {
    width: 100%;
    display: flex;
}

.article-form-left {
    width: 670px;
}

.article-form-right {
    flex: 1 1 auto;
    min-width: 400px
}

.form-iframe {
    width: 100%;
    height: calc(100vh - 114px);
}

.el-tag+.el-tag {
    margin-left: 10px;
}

.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}

.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}
</style>
